<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details" style="overflow-x: hidden;">
  <div class="row">
    <div class="truck-right-header">
      <span><img src="assets/img/location.svg" /> <a>Track</a></span>
      <span (click)="goToNotifications()" style="cursor: pointer;"> <img
          src="assets/img/bell.svg" />Notifications</span>
      <span>
        <div class="dropdown" matTooltip="Profile">
          <a mat-button [matMenuTriggerFor]="menu"><img class="header-profile"
              src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}" />Hi,
            <span style="text-transform: capitalize">{{userName}}</span>
          </a>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="GoToProfile()">Profile</button>
            <div class="seperator"></div>
            <button mat-menu-item (click)="GoToOrders()">Orders</button>
            <div class="seperator"></div>
            <button mat-menu-item (click)="logout()">Logout</button>
          </mat-menu>
        </div>
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 truck-owner-header-search" *ngIf="preorderType !== 'Quote'">
      <input id="driverNumber" #newItem placeholder="Search by WO ID" (keyup)="onInputChange(newItem)"
        (keyup.enter)="isInputValid && search(newItem.value)" toUppercase />
      <a class="truck-header-search-icon" *ngIf="search_btn">
        <img (click)="search(newItem.value)" src="../../../assets/img/search.svg" />
      </a>
      <a class="truck-header-search-icon" *ngIf="clear_btn">
        <img (click)="resetSearch()" src="../../../assets/img/cross_icon.svg" />
      </a>
    </div>
    <div class="col-md-6" *ngIf="preorderType !== 'Quote'"></div>

    <div class="col-md-12 mb-3 truck-owner-header-search" *ngIf="preorderType === 'Quote'">
      <form [formGroup]="activeQuoteSearchForm" (ngSubmit)="quoteList(-1)" class="d-flex align-items-center" style="gap: 15px;">
        <div class="form-group mb-0 flex-grow-1 position-relative">
          <input type="text" #fromInput formControlName="from" placeholder="From City">
        </div>
        <div class="form-group mb-0 flex-grow-1 position-relative">
          <input type="text" #toInput formControlName="to" placeholder="To City">
        </div>
        <div class="form-group mb-0 flex-grow-1 position-relative">
          <select class="form-select" formControlName="category" style="height: 46px; width: 100%; background: #ffffff; box-shadow: 0px 0px 4px rgb(0 0 0 / 25%); border-radius: 34px; border: none; font-family: 'SF Pro'; font-size: 16px; padding: 0 20px; color: #aaaaaa; appearance: none; -webkit-appearance: none; -moz-appearance: none;">
            <option value="">Select Category</option>
            <option *ngFor="let cat of truckCategory" [value]="cat._id">
              {{ cat.truck_category_name }}
            </option>
          </select>
        </div>
        <button type="submit" class="btn" style="background-color: #f53434; color: white; min-width: 100px; height: 46px; border-radius: 34px; font-family: 'SF Pro Display', sans-serif; font-weight: 500; font-size: 16px;">Search</button>
        <button type="button" class="btn" style="background-color: #747474; color: white; min-width: 100px; height: 46px; border-radius: 34px; font-family: 'SF Pro Display', sans-serif; font-weight: 500; font-size: 16px;" (click)="activeQuoteSearchForm.reset({from: '', to: '', category: ''}); quoteList(-1)">Clear</button>
      </form>
    </div>

    <div class="col-md-12">
      <mat-card>
        <div class="trip-acoordion">
          <!-- <a [ngClass]="{ active: preorderType == 'All' }" (click)="getTripsList('All')">All</a> -->
          <a [ngClass]="{ active: preorderType == '-1' }" (click)="getTripsList('-1')">PreOrders</a>
          <a [ngClass]="{ active: preorderType == 'Quote' }" (click)="getTripsList('Quote')">Active Quotes</a>
          <a></a>
          <a></a>
        </div>
      </mat-card>
    </div>
  </div>

  <div class="truck-owner-items to_container">
    <!-- <div [class.spinner]="loading"></div> -->

    <!-- Loading Spinner -->
    <div *ngIf="loading" class="spinner"></div>

    <!-- No Records Message -->
    <div class="row to_container" *ngIf="!preOrderData.length && !loading">
      <h4 class="error_msg">No Records Found.</h4>
    </div>

    <!-- Main Content -->
    <div class="row">
      <ng-container *ngIf="!loading && wo1">
        <div class="col-sm-4 row-gap" *ngFor="let preorder of preOrderData">
          <div class="premium-preorder-card">
            <mat-card class="truck-list">
              <div class="header-row">
                <span class="header_cls">
                  <span class="new-order-date">{{ preorder.pickup_date | date : "dd-MM-yyyy" }}</span>
                </span>
                <button class="order-button">
                  {{ preorder.workorder_id || preorder.trip_id }}
                </button>
              </div>
              <div class="row">
                <div class="col-md-12 truck_details_loc">
                  <img [src]="preorder.stops?.length > 0
                            ? '../../../assets/img/location-payment-stop.svg'
                            : '../../../assets/img/location-payment.svg'"
                    [matTooltip]="preorder.stops?.length > 0 ? ('Stops: ' + preorder.stops.length) : ''"
                    [matTooltipDisabled]="!(preorder.stops?.length > 0)" matTooltipPosition="right" alt="" />
                  <div class="places">
                    <p class="pickup-place">{{ preorder.pickup_details.from_city_name }}</p>
                    <p class="dropoff-place">{{ preorder.dropoff_details.to_city_name }}</p>
                  </div>
                </div>
              </div>

              <!-- Details Grid (2x2) -->
              <div class="details-grid mt-2">
                <!-- Company Name (replacing date) -->
                <div class="detail-item">
                  <div class="icon-container">
                    <img src="../../../assets/img/profilesimg.svg" alt="Company" class="detail-icon" />
                  </div>
                  <div class="detail-info">
                    <span class="detail-label">Company</span>
                    <span #companyNameEl
                          class="detail-value text-truncate"
                          [matTooltip]="preorder.userInfo?.company_name || preorder.userInfo?.username || 'N/A'"
                          [matTooltipDisabled]="companyNameEl.scrollWidth <= companyNameEl.clientWidth">
                      {{ preorder.userInfo?.company_name || preorder.userInfo?.username || 'N/A' }}
                    </span>
                  </div>
                </div>

                <!-- Material Type -->
                <div class="detail-item">
                  <div class="icon-container">
                    <img src="../../../assets/img/box.svg" alt="Material" class="detail-icon" />
                  </div>
                  <div class="detail-info">
                    <span class="detail-label">Material</span>
                    <span class="detail-value text-truncate">
                      {{ preorder.material_type }}
                    </span>
                  </div>
                </div>

                <!-- Truck Category -->
                <div class="detail-item">
                  <div class="icon-container">
                    <img src="../../../assets/img/truck (1).svg" alt="Truck" class="detail-icon" />
                  </div>
                  <div class="detail-info">
                    <span class="detail-label">Truck</span>
                    <span class="detail-value text-truncate">
                      {{ preorder.truckcategoryInfo?.[0]?.truck_category_name || preorder.truck_category?.truck_category_name || truckCategoryMap[preorder.truck_category] || "Unknown" }}
                    </span>
                  </div>
                </div>

                <!-- Weight -->
                <div class="detail-item">
                  <div class="icon-container">
                    <img src="../../../assets/img/weight1.svg" alt="Weight" class="detail-icon" />
                  </div>
                  <div class="detail-info">
                    <span class="detail-label">Weight</span>
                    <span class="detail-value">
                      {{ preorder.total_tons ? (preorder.total_tons | number : "1.2-2") + ' MT' : preorder.truckTypeInfo?.[0]?.truck_weight || preorder.truck_type?.truck_weight || 'N/A' }}
                    </span>
                  </div>
                </div>
              </div>
            </mat-card>

            <div class="credit_trip">
              <ng-container *ngIf="preorder.trip_status !== 'quote'">
                <button class="reject-button" [disabled]="
                    (preorder.truckownerBidInfo && preorder.truckownerBidInfo[0]?.truckowner_bid_status === 'rejected') ||
                    (preorder.truckownerBidInfo && preorder.truckownerBidInfo[0]?.truckowner_bid_status === 'accepted') ||
                    preorder.workorder_expiry_time < currentTime
                  " [ngStyle]="{
                    'background-color':
                      preorder.workorder_expiry_time < currentTime
                        ? '#888888'
                        : preorder.truckownerCreditTripCount != 0 || (preorder.truckownerBidInfo && preorder.truckownerBidInfo[0]?.truckowner_bid_status === 'rejected') || (preorder.truckownerBidInfo && preorder.truckownerBidInfo[0]?.truckowner_bid_status === 'accepted')
                          ? '#d57474'
                          : '#f53434'
                  }" (click)="RejectPreorder(preorder, 'rejected')">
                  {{
                  (preorder.truckownerBidInfo && preorder.truckownerBidInfo[0]?.truckowner_bid_status === 'rejected')
                  ? 'Rejected'
                  : preorder.workorder_expiry_time < currentTime ? 'Bid Expired' : 'Reject' }}
                </button>
                <button class="success-button" [disabled]="
                    preorder.truckownerBidInfo && preorder.truckownerBidInfo[0]?.truckowner_bid_status === 'rejected'
                  " [ngStyle]="{
                    'background-color':
                      preorder.workorder_expiry_time < currentTime
                        ? '#888888'
                        : (preorder.truckownerBidInfo && preorder.truckownerBidInfo[0]?.truckowner_bid_status === 'rejected')
                          ? '#64bd83'
                          : '#11dd57'
                  }" (click)="bid(preorder)">
                  {{
                  (preorder.truckownerBidInfo && preorder.truckownerBidInfo[0]?.truckowner_bid_status === 'rejected')
                  ? 'Bid Details'
                  : preorder.workorder_expiry_time < currentTime ? 'Bid Details' : 'BID' }}
                </button>
              </ng-container>

              <ng-container *ngIf="preorder.trip_status === 'quote'">
                <button class="success-button quote-bid-button" style="background-color: #11dd57;" (click)="bid(preorder)">
                  BID
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="row" *ngIf="wo2">
        <div class="col-sm-12">
          <div class="workOrder-card">
            <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
              <div class="row trip-view-top" style="margin-top: 12px">
                <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 trip-view-top-left">
                  <img src="assets/img/trip.svg" alt="" />
                  <div>
                    <h6>{{ selectedData.workorder_id }}</h6>
                    <div style="font-size: 12px; color: #f58634; font-weight: 600; margin-left: 10px; margin-top: 2px;">
                      {{ selectedData.userInfo?.company_name || 'N/A' }}
                    </div>
                  </div>
                </div>
                <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 trip-view-top-right">
                  <div class="trip-top-right-top">
                    {{ selectedData.truckcategoryInfo[0].truck_category_name }}
                  </div>
                  <div class="trip-top-right-middle">
                    <span class="location-1">{{
                      selectedData.pickup_details.from_city_name
                      }}</span>
                    <span class="location-img"><img src="assets/img/trip-location.svg" alt="" /></span>
                    <span class="location-2">{{ selectedData.dropoff_details.to_city_name }}
                    </span>
                  </div>
                  <div class="trip-top-right-bottom">
                    {{ selectedData.load_type }}:
                    {{ selectedData.material_type }}
                  </div>
                </div>
              </div>
              <div class="trip-view-bottom row d-flex justify-content-center">
                <div class="trips-amount">
                  <a>Pickup Location:</a>
                  <div>
                    <p>{{ selectedData.from_complete_address }}</p>
                  </div>
                </div>
                <div class="trips-amount" *ngIf="selectedData?.stops?.length > 0">
                  <a>Stops:</a>
                  <div *ngFor="let stop of selectedData?.stops; let i = index">
                    <p>
                      {{ i + 1 }}. {{ stop.city_name }}
                    </p>
                  </div>
                </div>
                <div class="trips-amount">
                  <a>Drop Off Location:</a>
                  <div>
                    <p>
                      {{ selectedData.to_complete_address }}
                    </p>
                  </div>
                </div>

                <div class="trips-amount">
                  <a>Date:</a>
                  <div>
                    <p>{{ selectedData.createdAt | date : "dd-MM-yyyy" }}</p>
                  </div>
                </div>
                <div class="trips-amount">
                  <a>Total Weight:</a>
                  <div>
                    <p>{{ selectedData.total_tons | number : "1.2-2" }} MT</p>
                  </div>
                  <a>Remaining Weight:</a>
                  <div>
                    <p>{{ selectedWorkOrder?.remaining_tons | number : '1.2-2' }} MT</p>
                  </div>
                </div>
                <div class="trips-amount">
                  <a>Base Price:</a>
                  <div>
                    <p>Rs. {{ (selectedWorkOrder?.price_per_ton || selectedData?.price_per_ton) | number : '1.2-2' }} /MT</p>
                  </div>
                  <a>Lowest Bid Rate:</a>
                  <div>
                    <p>
                      <ng-container *ngIf="(currentLowestBidRate || selectedWorkOrder?.lowest_bid_rate || selectedData?.lowest_bid_rate); else noLowestBid">
                        Rs. {{ (currentLowestBidRate || selectedWorkOrder?.lowest_bid_rate || selectedData?.lowest_bid_rate) | number : '1.2-2' }} /MT
                      </ng-container>
                      <ng-template #noLowestBid>-</ng-template>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
              <div class="trip-view-left">
                <!-- check finalizingResults flag -->
                <!-- Bidding Timer -->
                <button *ngIf="!finalizingResults && socketTimer?.remainingTime !== 'Expired'" class="time-left">
                  <p>Bidding Timer</p>
                  <h5>{{ socketTimer?.remainingTime }}</h5>
                </button>

                <!-- Add Truck Timer -->
                <button *ngIf="isRankingTimeExpired(bidRateData?.ranking_expiry_time)" class="time-left">
                  <p>Add Truck Timer</p>
                  <h5>{{ getRemainingTime(bidRateData?.ranking_expiry_time) }}</h5>
                </button>

                <!-- Finalizing Results UI -->
                <!-- <div *ngIf="finalizingResults">
                  <button class="res-btn">
                    <div class="dot-pulse-loader">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </div>
                  </button>
                </div> -->

                <!-- Bid Rate Button -->
                <button class="add-truck mt-2" *ngIf="!finalizingResults && socketTimer?.remainingTime !== 'Expired'"
                  [ngStyle]="{
                  'margin-bottom': '14px',
                  'background-color': submittedBidRate !== null ? '#f8a5a5' : '#f53434',
                  'cursor': submittedBidRate !== null ? 'not-allowed' : 'pointer'
                }" [disabled]="submittedBidRate !== null" (click)="openBidRateDialog()">
                  Bid Rate
                </button>

                <!-- Add Truck Button with Progress Loader -->
                <button
                  *ngIf="isRankingTimeExpiredBtn(bidRateData?.ranking_expiry_time, selectedData?.corporate_ranking_timer)"
                  class="progress-button add-truck mt-2"
                  [disabled]="isLoading || selectedWorkOrder?.remaining_tons <= 0" [ngStyle]="{
                    'background-color': selectedWorkOrder?.remaining_tons <= 0 || isLoading ? '#ffdcdc': '#f53434',
                    'color': selectedWorkOrder?.remaining_tons <= 0 || isLoading ? '#f53434' : '#ffffff',
                    'cursor': selectedWorkOrder?.remaining_tons <= 0 || isLoading ? 'not-allowed' : 'pointer',
                    'margin-bottom': '14px'
                  }" (click)="openTruckDialogWithLoader('add')">
                  <div class="fill-layer" [ngStyle]="{ width: progress + '%' }" *ngIf="isLoading"></div>
                  <span class="button-label">Add Truck</span>
                </button>

                <!-- Fallback: Expired -->
                <button
                  *ngIf="socketTimer?.remainingTime === 'Expired' 
                        && !isRankingTimeExpired(bidRateData?.ranking_expiry_time)
                        && !isRankingTimeExpiredBtn(bidRateData?.ranking_expiry_time, selectedData?.corporate_ranking_timer)"
                  class="time-left">
                  <p>Time Left:</p>
                  <h4 style="color: red;">Expired</h4>
                </button>

                <!-- Finalizing Results UI -->
                <div *ngIf="finalizingResults">
                  <button class="res-btn">
                    <!-- <p>Fetching Results...</p> -->
                    <div class="dot-pulse-loader">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </div>
                  </button>
                </div>

                <!-- lowestBidRate -->
                <div class="lowest-bid-badge my-2" *ngIf="lowestBidRate && bidRateData?.bid_ranking !== 'L1'">
                  L1 Price: <strong>Rs. {{ lowestBidRate | number: '1.0-0' }}/MT</strong>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bid-details" *ngIf="bidRateData && bidRateData.workorder_id === workOrderId">
        <div class="row bid-list">
          <div class="truck-details">
            <div class="col-sm-6 details text-center">
              <p>Submitted Bid Rate:</p>
            </div>
            <div class="col-sm-6 results text-center">
              <p>Rs {{ submittedBidRate | number: '1.2-2' }}</p>
            </div>

            <!-- Ranking Message -->
            <div class="col-12" *ngIf="bidRateData?.bid_ranking">
              <!-- L1 Message -->
              <div class="alert alert-success d-flex align-items-center ranking-box" role="alert"
                *ngIf="bidRateData.bid_ranking === 'L1'">
                <i class="bi bi-check-square-fill me-2"></i>
                <span>You got the <strong>{{ bidRateData.bid_ranking }}</strong> for this order. Please add truck
                  details within <strong>{{ selectedData.corporate_ranking_timer }} minutes</strong> to confirm your
                  booking</span>
              </div>

              <!-- L2 Message -->
              <div class="alert alert-warning d-flex align-items-center ranking-box" role="alert"
                *ngIf="bidRateData.bid_ranking !== 'L1' && bidRateData.bid_ranking !== 'Price Exceeded'">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                <span>
                  You got <strong>{{ bidRateData.bid_ranking }}</strong> for this order.
                  If others fail to add the truck and driver, your <strong>Add Truck</strong> button will be enabled
                  <strong>{{ selectedData.corporate_ranking_timer }} minutes</strong> before the timer expires.
                </span>
              </div>

              <!-- Price Exceeded / Rejected -->
              <div class="alert alert-danger d-flex align-items-center ranking-box" role="alert"
                *ngIf="bidRateData.bid_ranking === 'Price Exceeded'">
                <i class="bi bi-x-circle-fill me-2"></i>
                <span>We regret to inform you that you did not get this order. You can still place your bids for other
                  available orders.</span>
              </div>
            </div>

            <div class="btn-sec">
              <button class="btn btn-secondary" [disabled]="socketTimer?.remainingTime === 'Expired'"
                (click)="confirmDeleteBidRate()">
                DELETE RATE
              </button>
              <button class="btn btn-success" [disabled]="socketTimer?.remainingTime === 'Expired'"
                (click)="openBidRateDialog()">
                EDIT RATE
              </button>`
            </div>
          </div>
        </div>
      </div>

      <div class="bid-details" *ngIf="bid_list">
        <div class="row bid-list">
          <div class="truck-details" *ngFor="let bid of bidData">
            <div class="col-sm-6 details">
              <p>Truck Number:</p>
              <p>Driver Number:</p>
              <p>Truck Category:</p>
              <p>Truck Type:</p>
              <p>Price/MT:</p>
              <p>Trip ID/Status:</p>
            </div>
            <div class="col-sm-6 results">
              <p>{{ bid.truckInfo[0].truck_number }}</p>
              <p>{{ bid.driverInfo[0].mobile }}</p>
              <p>{{ bid.truckCategoryInfo[0].truck_category_name }}</p>
              <p>{{ bid.truckTypeInfo[0].truck_weight }}</p>
              <p>{{ bid.price | number : "1.2-2" }}</p>
              <p>{{ bid.tripBookingInfo[0]?.trip_id }} {{ bid.trip_status | uppercase }}</p>
            </div>
            <!-- <div class="btn-sec">
              <button
                class="btn btn-secondary"
                [disabled]="socketTimer?.remainingTime === 'Expired'"
                (click)="reject('delete', bid)"
              >
                DELETE BID
              </button>
              <button
                class="btn btn-success"
                [disabled]="socketTimer?.remainingTime === 'Expired'"
                (click)="addTruck('edit', bid)"
              >
                EDIT BID
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!loading && last_page && last_page > 1 && wo1" class="pagination">
      <button class="btn" [disabled]="fetch_page == 1">
        <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2" (click)="pagination('-1')">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button class="btn" [disabled]="fetch_page == 1">
        <img src="../../../assets/img/pagination-left.svg" (click)="pagination('first')" alt="" class="btn--icon" />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button class="btn" [disabled]="last_page == fetch_page">
        <img src="../../../assets/img/pagination-right.svg" (click)="pagination('last')" alt="" class="btn--icon" />
      </button>
      <button class="btn" [disabled]="last_page == fetch_page">
        <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2" (click)="pagination('1')">
          <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
</div>